import { createAction, props } from '@ngrx/store';
import { User, UserSearchResult } from '../../models/user.model';
import { UserSortState } from '../states/users.state';

export const loadUsers = createAction('[Users] Load Users', props<{ query: User }>());

export const loadUsersSuccess = createAction(
  '[Users API] Load Users Success',
  props<{ users: UserSearchResult[] }>()
);

export const loadUsersFailure = createAction(
  '[Users API] Load Users Failure',
  props<{ error: any }>()
);

export const getUser = createAction('[Users] Get User', props<{ userId: number }>());
export const getUserSuccess = createAction('[Users API] Get User Success', props<{ user: User }>());
export const getUserFailure = createAction(
  '[Users API] Get User Failure',
  props<{ error: string }>()
);

export const updateUser = createAction(
  '[Users] Update User',
  props<{ user: User; selectedFile: File | undefined }>()
);

export const updateUserSuccess = createAction(
  '[Users API] Update User Success',
  props<{ user: User }>()
);

export const updateUserFailure = createAction(
  '[Users API] Update User Failure',
  props<{ error: any }>()
);

export const deleteUser = createAction('[Users] Delete User', props<{ id: number }>());

export const deleteUserSuccess = createAction(
  '[Users API] Delete User Success',
  props<{ id: number }>()
);

export const deleteUserFailure = createAction(
  '[Users API] Delete User Failure',
  props<{ error: any }>()
);

export const clearUsers = createAction('[Users API] clear Users');
export const clearUser = createAction('[Users API] clear User');

export const changeUserSort = createAction(
  '[Users] Change Sort',
  props<{ active: UserSortState['active']; direction: UserSortState['direction'] }>()
);

export const changeUserPage = createAction('[Users] Change Page', props<{ pageIndex: number }>());

export const changeUserPageSize = createAction(
  '[Users] Change Page Size',
  props<{ pageSize: number }>()
);

export const loadUserViewPreference = createAction('[View] Load User View Preference');

export const setUserMapView = createAction(
  '[View] Set User Map View',
  props<{ isUserMapView: boolean }>()
);

export const toggleUserMapView = createAction('[View] Toggle User Map View');
